import { createAction, handleActions } from 'redux-actions';

// ACTION TYPES
const CONSULTAR_CEP = `${process.env.PUBLIC_URL}/ENDERECO/CONSULTAR_CEP`;
const STORE_UPDATE_ENDERECO = `${process.env.PUBLIC_URL}/ENDERECO/STORE_UPDATE`;
const CONSULTAR_ESTADO = `${process.env.PUBLIC_URL}/ENDERECO/CONSULTAR_ESTADO`;
const CONSULTAR_MUNICIPIO = `${process.env.PUBLIC_URL}/ENDERECO/CONSULTAR_MUNICIPIO`;
const LIMPAR_DADOS_ENDERECO = `${process.env.PUBLIC_URL}/ENDERECO/LIMPAR_DADOS_ENDERECO`;

export const types = {
  CONSULTAR_CEP,
  CONSULTAR_ESTADO,
  CONSULTAR_MUNICIPIO,
  LIMPAR_DADOS_ENDERECO,
  STORE_UPDATE_ENDERECO
};

// ACTIONS
const consultarCep = createAction(CONSULTAR_CEP);
const consultarEstado = createAction(CONSULTAR_ESTADO);
const consultarMunicipio = createAction(CONSULTAR_MUNICIPIO);
const limparDadosEndereco = createAction(LIMPAR_DADOS_ENDERECO);
const updateStore = createAction(STORE_UPDATE_ENDERECO);

export const actions = {
  consultarCep,
  consultarEstado,
  consultarMunicipio,
  limparDadosEndereco,
  updateStore,
};

// INITIAL STATE
const initialState = {};

// REDUCERS
const reducer = handleActions({
  [STORE_UPDATE_ENDERECO]: (state, action) => ({
    ...state,
    ...action.payload
  }),
  [LIMPAR_DADOS_ENDERECO]: (state, action) => ({
    ...state,
    estados: [],
    municipios: [],
    dadosConsultaCep: null
  })
}, initialState);

export default reducer;

const getEstados = state => state.enderecos.estados || [];

const getMunicipios = state => state.enderecos.municipios || [];

const getDadosConsultaCep = state => state.enderecos.dadosConsultaCep || {}

export const selectors = {
  getEstados,
  getMunicipios,
  getDadosConsultaCep
};
